import { render, staticRenderFns } from "./ModalSolicitarReadequacao.vue?vue&type=template&id=2b182c1a&scoped=true"
import script from "./ModalSolicitarReadequacao.vue?vue&type=script&lang=js"
export * from "./ModalSolicitarReadequacao.vue?vue&type=script&lang=js"
import style0 from "./ModalSolicitarReadequacao.vue?vue&type=style&index=0&id=2b182c1a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b182c1a",
  null
  
)

export default component.exports